<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="purchPriceExportRef" :fields="fields" :title="table_title.title1"
        :show_query_container="false" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :hb_table_class="'hb_table_vpqe_out_class1'" @state_change="state_change"
        :show_toolbar_button="[0, 0, 0, 0, 1]" @tool_invoke="tool_invoke" @current_changed="current_changed" tableref="0490a751d8874fe990c6e694eb7e1909">
        <template #toolbar="">
          <div style="display: inline-block">
            <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" accept=".xlsx"
              :on-exceed="exceed" :limit="1" :on-remove="remove" :http-request="uploadFile"
              :before-upload="beforeFileUpload" :show-file-list="false" :file-list="fileList" :on-success="successFile">
              <el-button plain type="info" style="width: 55px" class="ml-2"><i
                  class="iconfont icon-export-in"></i></el-button>
              <!-- <div slot="tip" class="el-upload__tip">1次只能上传1个xls文件</div> -->
            </el-upload>
          </div>
          <!-- <a href="" class="ml-2 mb-0">模板下载</a> -->
          <el-tooltip content="模板下载" placement="top" effect="light">
            <el-button plain type="info" style="width: 55px" @click="downloadTemplate" class="ml-2"><i
                class="iconfont icon-template"></i>
            </el-button>
          </el-tooltip>
        </template>
        <template #operation>
          <QueryButton v-if="type_code == 'internal'" :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'"
            @on_query="saveExport" :label="$t('common.save')" class="ml-2"></QueryButton>
        </template>
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
import XLSX from "xlsx"
import * as commonController from '../../controllers/commonController'
import * as VendPurchaseQuoteExportController from "../../controllers/sd/VendPurchaseQuoteExportController"
import * as base_url from "../../shared/base_url"
import QueryButton from "../components/base/QueryButton"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
export default {
  name: "saleOrderDispatch",
  components: {
    QueryButton,
    BaseContainer,
    TableMain,
  },
  props: {
    type_code: { type: String, default: "" }
  },
  data() {
    return {
      fileList: [],
      table_title: {
        title1: "table_vend_purch_price_import_internal",
      },
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      fields: VendPurchaseQuoteExportController.fields.default,
      dataList: [],
      base_url: base_url.base_url,
    }
  },
  created() { },
  methods: {
    downloadTemplate() {
      window.location.href =
        this.base_url + "/excel_template/" + "供应商采购报价导入模板20240802.xlsx"
    },
    current_changed(old, current) { },
    tool_invoke(data) { },
    state_change(data, cb) {
      if (data.state === "deleted") {
        this.$refs.purchPriceExportRef.RemoveItems(data.selected_items)
      }
    },
    //上传1个以上文件时弹窗提示错误
    exceed: function () {
      if (this.type_code == "internal") {
        let has_in_privilige = commonController.methods.checkPrivilige(this, "z-InternalVendQuote", "内部供应商报价操作权限")
        if (!has_in_privilige) {
          return
        }
      }
      else {
        let has_out_privilige = commonController.methods.checkPrivilige(this, "z-OutsideVendQuote", "外部供应商报价操作权限")
        if (!has_out_privilige) {
          return
        }
      }
      //this.$message.error("最多只能上传1个xls文件");
      this.msgToasts("最多只能上传1个xls文件！", "info")
    },
    //删除
    remove() { },
    successFile() {
      //this.isBusy_table3 = false
    },
    async uploadFile(params) {
      if (this.type_code == "internal") {
        let has_in_privilige = commonController.methods.checkPrivilige(this, "z-InternalVendQuote", "内部供应商报价操作权限")
        if (!has_in_privilige) {
          return
        }
      }
      else {
        let has_out_privilige = commonController.methods.checkPrivilige(this, "z-OutsideVendQuote", "外部供应商报价操作权限")
        if (!has_out_privilige) {
          return
        }
      }

      this.isBusy_table = true
      let _this = this
      let _file = params.file
      let fileReader = new FileReader()
      fileReader.onload = (ev) => {
        try {
          let data = ev.target.result
          let workbook = XLSX.read(data, {
            type: "binary",
            cellDates: true,
          })
          let fields = []
          let listTable = []
          for (let sheet in workbook.Sheets) {
            if (sheet.indexOf("参考表") > -1) {
              continue
            }

            let sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets[sheet], {
              defval: "",
            })
            if (sheetArray.length == 0) {
              continue
            }

            let _tmpModel = [
              {
                value: "AccountNum",
                key: "供应商编码",
              },
              {
                value: "ItemId",
                key: "物料编号",
              },
              {
                value: "VariantName",
                key: "变型名称",
              },
              {
                value: "Amount",
                key: "单价",
              },
              {
                value: "Tax",
                key: "税率",
              },
              {
                value: "Symbol",
                key: "单位",
              },
              {
                value: "CurrencyCode",
                key: "币别",
              },
              {
                value: "FromDate",
                key: "开始日期",
              },
              {
                value: "ToDate",
                key: "结束日期",
              },
              {
                value: "QuantityAmountFrom",
                key: "数量开始",
              },
              {
                value: "QuantityAmountTo",
                key: "数量结束",
              },
              {
                value: "Remark",
                key: "价格备注",
              },
              {
                value: "EXP",
                key: "EXP",
              },
              {
                value: "M11",
                key: "M11纸张",
              },
              {
                value: "M12",
                key: "M21油墨",
              },
              {
                value: "M22",
                key: "M22光油",
              },
              {
                value: "M23",
                key: "M23胶水",
              },
              {
                value: "M24CTP",
                key: "M24CTP版",
              },
              {
                value: "M25",
                key: "M25其他辅料",
              },
              {
                value: "M26",
                key: "M26办公劳保",
              },
              {
                value: "O11",
                key: "O11直接人工",
              },
              {
                value: "O12",
                key: "O12间接人工",
              },
              {
                value: "O23",
                key: "O23电",
              },
              {
                value: "O24",
                key: "O24折旧",
              },
              {
                value: "O25",
                key: "O25其他变动费用",
              },
              {
                value: "O26",
                key: "O26其他固定费用",
              },
              {
                value: "S11",
                key: "S11委外加工费",
              },
              {
                value: "X",
                key: "X备件",
              },
              {
                value: "Y",
                key: "Y半成品",
              },
              {
                value: "Z",
                key: "Z成品",
              },
              {
                value: "Cost_detail",
                key: "成本明细号",
                sortable: true,
              },
            ]
            for (var _fm in _tmpModel) {
              let _field_model = { key: "", label: "" }
              let _key = _tmpModel[_fm].value
              let _label = _tmpModel[_fm].key
              _field_model.label = _label
              _field_model.key = _key
              fields.push(_field_model)
            }
            for (var i = 0, l = sheetArray.length; i < l; i++) {
              let _data = []
              for (var key in sheetArray[i]) {
                if (_.isDate(sheetArray[i][key])) {
                  sheetArray[i][key] = this.$date.addDays(
                    sheetArray[i][key],
                    1
                  )
                }
                _data.push({ key: key, value: sheetArray[i][key] })
              }
              let dif = _.differenceBy(_data, _tmpModel, "key")
              if (dif.length > 0) {
                // this.$message.warning("文件类型不正确！");
                this.msgToasts("文件类型不正确!", "info")

                return
              }
            }
            listTable = sheetArray.map(function (o) {
              return {
                AccountNum: o["供应商编码"],
                ItemId: o["物料编号"],
                VariantName: o["变型名称"],
                Amount: o["单价"],
                Symbol: o["单位"],
                CurrencyCode: o["币别"],
                FromDate: o["开始日期"]
                  ? _this.$date.format(new Date(o["开始日期"]), "yyyy-MM-dd")
                  : "",
                ToDate: o["结束日期"]
                  ? _this.$date.format(new Date(o["结束日期"]), "yyyy-MM-dd")
                  : "",
                QuantityAmountFrom: o["数量开始"],
                QuantityAmountTo: o["数量结束"],
                Remark: o["价格备注"],
                EXP: o["EXP"],
                M11: o["M11纸张"],
                M12: o["M21油墨"],
                M22: o["M22光油"],
                M23: o["M23胶水"],
                M24CTP: o["M24CTP版"],
                M25: o["M25其他辅料"],
                M26: o["M26办公劳保"],
                O11: o["O11直接人工"],
                O12: o["O12间接人工"],
                O23: o["O23电"],
                O24: o["O24折旧"],
                O25: o["O25其他变动费用"],
                O26: o["O26其他固定费用"],
                S11: o["S11委外加工费"],
                X: o["X备件"],
                Y: o["Y半成品"],
                Z: o["Z成品"],
                Cost_detail: o["成本明细号"],
              }
            })
            _this.$refs.purchPriceExportRef.SetData(listTable)
          }
        } catch (e) {
          console.log(e)
          // this.$message.warning("文件类型不正确！");
          this.msgToasts("文件类型不正确！!", "info")

          this.isBusy_table = false
        }
      }
      fileReader.readAsBinaryString(_file)
      this.isBusy_table = false
      this.fileList = []
    },
    //before上传
    beforeFileUpload() { },
    //保存
    async saveExport(cb) {
      if (this.$refs.purchPriceExportRef.my_data.length < 1) {
        cb(false)
        return
      }

      //负数检查
      let _bool = true
      _.each(this.$refs.purchPriceExportRef.my_data, (t) => {
        if (t.Amount < 0) {
          let item = this.$refs.purchPriceExportRef.my_data[parseInt(t._id)]
          item._rowVariant = "danger"
          item._selected = true
          this.$set(this.$refs.purchPriceExportRef.my_data, t._id, item)
          _bool = false
        }
      })
      if (!_bool) {
        this.msgToasts("单价不能为负!", "error")
        cb(false)
        return
      }
      //return;
      let data = { username: this.$global.global_data.local_username }
      data.data = this.$refs.purchPriceExportRef.my_data
      // //获取物料信息
      // if (!(await this.getNameAlias())) {
      //   return;
      // }
      // //获取客户信息
      // if (!(await this.getCustInfo())) {
      //   return;
      // }
      let result =
        await VendPurchaseQuoteExportController.methods.SavePurchaseQuoteExport(
          JSON.stringify(data)
        )

      if (result && result.length > 0) {
        //判断后台是否写入成功
        if (result[0][0].status == 0) {
          this.$refs.purchPriceExportRef.SetData([])
          this.msgToasts(this.$t("notify.import_success"), "success")
          this.$refs.purchPriceExportRef.SetData([])
          cb(true, true)
        } else {
          let str = "<div><strong>" + this.$t("notify.import_failed_error") + "</strong></div>"
          _.each(result[0], (t) => {
            if (
              _.isNull(t.NameAlias) ||
              _.isNull(t.TaxGroup) ||
              _.isNull(t.SEI_Name)
            ) {
              console.log(t)
              //标红错误行
              let item =
                this.$refs.purchPriceExportRef.my_data[parseInt(t._id)]
              item._rowVariant = "danger"
              item._selected = true
              this.$set(this.$refs.purchPriceExportRef.my_data, t._id, item)
              str += this.ErrorMsg(t)
              // let _item = _.find(this.$refs.purchPriceExportRef.my_data,{_id:t._id})
              // this.$refs.purchPriceExportRef.setSelect(_item);
            }
          })
          this.msgToasts(str, "error", 0, true, "notify550")
          cb(false)
          return
        }
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
        cb(false)
        return
      }
      //return
      // if (!(await this.savePurchPrice(this.dataList))) {
      //   cb(true, false);
      // } else {
      //   cb(true, true);
      // }
      //插入code output code
      //插入saleTable output salesId mixIn code
      //插入saleLine mixIn salesId
    },
    ErrorMsg(data) {
      if (_.isNull(data.NameAlias)) {
        return ("<div>" + this.$t("common.provider") + ":<strong>" + data.AccountNum + "</strong>，" + this.$t("common.invent") + ":<strong>" + data.ItemId + "</strong>，<strong>" + this.$t("common.invent") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.SEI_Name)) {
        return ("<div>" + this.$t("common.provider") + ":<strong>" + data.AccountNum + "</strong>，" + this.$t("common.invent") + ":<strong>" + data.ItemId + "</strong>，<strong>" + this.$t("common.provider") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.TaxGroup)) {
        return ("<div>" + this.$t("common.provider") + ":<strong>" + data.AccountNum + "</strong>，" + this.$t("common.invent") + ":<strong>" + data.ItemId + "</strong>，<strong>" + this.$t("common.tax_name") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      return ""
    },
    async savePurchPrice(data) {
      let _result =
        await VendPurchaseQuoteExportController.methods.savePurchPrice(data)

      if (!_result) {
        this.msgToasts("导入失败！", "info")
        return false
      }
      this.msgToasts(this.$t("notify.import_success"), "success")
      this.$refs.purchPriceExportRef.SetData([])
      return true
    },
    //获取供应商信息
    async getCustInfo() {
      let _result = await VendPurchaseQuoteExportController.methods.getCustInfo(
        this.dataList
      )
      if (!_result) {
        //this.$message.warning("导入失败,查询供应商信息失败！");
        this.msgToasts("导入失败,查询供应商信息失败！", "info")
        return false
      }
      let _this = this
      if (_result.length > 0) {
        if (_result[0].length > 0) {
          for (var i in _this.dataList) {
            let _item = _.find(_result[0], {
              AccountNum: _this.dataList[i].AccountNum.toString(),
            })
            if (_item) {
              _this.dataList[i].SEI_Name = _item.SEI_Name
              _this.dataList[i].TaxGroup = _item.TaxGroup
            } else {
              //this.$message.warning("导入失败,查询供应商信息失败！");
              this.msgToasts("导入失败,查询供应商信息失败！", "info")

              return false
            }
          }
        }
      }
      return true
    },
    //获取物料信息
    async getNameAlias() {
      this.dataList = this.$refs.purchPriceExportRef.my_data
      let _result =
        await VendPurchaseQuoteExportController.methods.getNameAlias(
          this.dataList
        )
      if (!_result) {
        //this.$message.warning("导入失败,查询物料失败！");
        this.msgToasts("导入失败,查询物料失败！", "info")

        return false
      }
      let _this = this
      if (_result.length > 0) {
        if (_result[0].length > 0) {
          for (var i in _this.dataList) {
            let _item = _.find(_result[0], {
              ItemId: _this.dataList[i].ItemId.toString(),
            })
            if (_item) {
              _this.dataList[i].NameAlias = _item.NameAlias
              _this.dataList[i].TEC_CustAccount = _item.TEC_CustAccount
              let _cus = _.find(_this.$store.state.biz_data.baseData.Customer, {
                AccountNum: _item.TEC_CustAccount.toString(),
              })
              if (_cus) {
                _this.dataList[i].DW_CustName = _cus.SEI_Name
              }
              //_this.dataList[i].DW_CustName = _item.DW_CustName;
              //如果物料档案中有变型名称,则对比两个变型名称是否一致
              if (_item.VariantName && _item.VariantName.trim() != "") {
                if (_item.VariantName != _this.dataList[i].VariantName) {
                  // _this.$message.warning(
                  //   "变型名称: <" +
                  //     _this.dataList[i].VariantName +
                  //     "> 与物料档案不一致!"
                  // );
                  _this.msgToasts(
                    "变型名称: <" +
                    _this.dataList[i].VariantName +
                    "> 与物料档案不一致!",
                    "info"
                  )
                  return false
                }
              }
              if (_this.dataList[i].VariantName == "") {
                _this.dataList[i].VariantName = _item.VariantName
              }
            } else {
              //_this.$message.warning("导入失败,查询物料失败！");
              this.msgToasts("导入失败,查询物料失败！", "info")
              return false
            }
          }
        }
      }
      return true
    },
  },
}
</script>
<style>
.hb_table_vpqe_out_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 180rem;
}
</style>
